import React, { useState } from "react"
import { graphql, Link } from "gatsby"
import Layout from "@components/layout"
import SEO from "@components/seo"
import marked from "marked"
import CurrencyFormatter from "../components/CurrencyFormatter"
import { Container, Row, Col } from "react-bootstrap"
import { StaticImage } from "gatsby-plugin-image"
import ProductCarousel from "@components/swiper/product-page"
import Sticker from "@components/swiper/sticker-swiper"
import AddToCart from "../components/bigcommerce/AddToCart"
import ProductOptions from "../components/bigcommerce/ProductOptions"
import Sticky from "react-sticky-el"
import { UncontrolledCollapse, Button, CardBody, Card } from "reactstrap"

const ProductTemplate = ({ data, pageContext }) => {
  const { bigCommerceProducts, sanityProduct, allSanityCategory } = data

  // const prodvid = sanityProduct
  // const products_section = sanityProduct[0] || []
  const [bcProduct, setBcProduct] = React.useState(null)
  const [bcProductVariant, setBcProductVariant] = React.useState(null)
  const [bcProductQty, setBcProductQty] = React.useState(1)
  const [loading, setLoading] = React.useState(true)
  const [bcStickers, setBcStickers] = React.useState([])

  const [isHide, setIsHide] = useState(true)

  const playButton = () => {
    setIsHide(false)
  }

  // let isBottles = false
  // const DrinkwareID = "-43e52acb-c072-5f69-8549-179f92152468"
  // const _sanityCategory = allSanityCategory.nodes.find(
  //   el => el.id === DrinkwareID
  // )
  // const _subCategories = sanityProduct?.productSubcategory || []
  // if (_subCategories.length && _sanityCategory) {
  //   if (_sanityCategory.productSubcategory.length) {
  //     for (let i = 0; i < _subCategories.length; i++) {
  //       const sub = _sanityCategory.productSubcategory.find(
  //         el => el.id === _subCategories[i].id
  //       )
  //       if (sub) {
  //         isBottles = true
  //         break
  //       }
  //     }
  //   }
  // }
  // console.log({ DrinkwareID, _sanityCategory, sanityProduct })

  const WATER_BOTTLES_ID = 49
  const STICKER_ID = 40
  const bigcommerce_id = bigCommerceProducts?.bigcommerce_id
  const isBottles = bigCommerceProducts?.categories?.includes(WATER_BOTTLES_ID)
  React.useEffect(() => {
    if (bigcommerce_id) {
      fetch(
        `/.netlify/functions/bigcommerce?endpoint=/v3/catalog/products&product_id=${bigcommerce_id}`
      )
        .then(res => res.json())
        .then(async ({ data }) => {
          setBcProduct(data)
          setBcProductVariant(data.variants[0])

          if (isBottles) {
            const stickers = await fetch(
              `/.netlify/functions/bigcommerce?endpoint=/v3/catalog/products&categories=${STICKER_ID}`
            ).then(res => res.json())
            setBcStickers(stickers?.data || [])
          }
        })
        .catch(err => console.log(err))
        .finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }, [bigcommerce_id, isBottles])

  return (
    <Layout>
      <SEO
        title={bcProduct?.page_title || "Shop"}
        description={bcProduct?.meta_description || ""}
      />
      <section
        className="shop-carousel-section"
        style={{
          backgroundImage: `url(${sanityProduct?.heroBG?.asset?.url ||
            "https://cdn.sanity.io/images/z3kdwuu9/production/34e2ace15771e4f1a03594db8c926d7d7622c85e-1280x775.png"})`,
        }}
      >
        <Container>
          <div className="product-hero-wrapper">
            {loading ? (
              <div className="text-center text-white">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
                <h5>Please wait..</h5>
              </div>
            ) : (
              <Row>
                <Col lg="6" className="mx-auto">
                  <div className="arbor-content text-left text-white">
                    <h1 className="font-italic section-title my-2 ">
                      {bcProduct?.name || ""}
                    </h1>
                    {sanityProduct?.productHeading && (
                      <div
                        className="my-2 mb-3 product-desc"
                        dangerouslySetInnerHTML={{
                          __html: marked(sanityProduct?.productHeading),
                        }}
                      />
                    )}
                    <Link
                      to="/"
                      className="review-stars text-decoration-underlined font-weight-bold text-white-50 mb-5 my-2"
                    >
                      <u>Reviews</u>
                    </Link>
                    <h3 className="price mb-5 mt-1 my-2">
                      <CurrencyFormatter
                        currency={"USD"}
                        amount={
                          bcProductVariant?.calculated_price ||
                          bcProduct?.calculated_price ||
                          0
                        }
                      />
                    </h3>
                    <div>
                      <ProductOptions
                        options={bcProduct?.options}
                        variant={bcProductVariant}
                        handleVariant={newVariant => {
                          const activeVariant = bcProduct.variants.find(
                            el =>
                              el.option_values.length === newVariant.length &&
                              el.option_values.every(function(element, index) {
                                return (
                                  JSON.stringify(element) ===
                                  JSON.stringify(newVariant[index])
                                )
                              })
                          )
                          setBcProductVariant(activeVariant)
                          // console.log({ activeVariant })
                        }}
                      />

                      {/* {bcProductVariant?.inventory_level === 0 && (
                        <div className="text-center mt-3">
                          <div class="alert alert-danger" role="alert">
                            Out of Stock
                          </div>
                        </div>
                      )} */}

                      <h5>Quantity</h5>
                      <div className="form-row align-items-center">
                        <div className="col-md-6">
                          <input
                            type="number"
                            className="form-control"
                            id="qty"
                            min={1}
                            value={bcProductQty}
                            onChange={e => setBcProductQty(e.target.value)}
                          />
                        </div>
                        <div className="col-md-6 addcart">
                          <AddToCart
                            item={bcProduct}
                            variant={bcProductVariant}
                            quantity={bcProductQty}
                          />
                        </div>
                      </div>

                      {sanityProduct?.promotion && (
                        <div
                          className="my-4 text-promotion"
                          style={{ color: "#F000FF" }}
                          dangerouslySetInnerHTML={{
                            __html: marked(sanityProduct?.promotion),
                          }}
                        />
                      )}

                      {isBottles && (
                        <div className="my-5">
                          <Sticker data={bcStickers} />
                        </div>
                      )}

                      {/* {bcProduct?.description && (
                        <div
                          className="mt-4 mb-5 product-desc"
                          dangerouslySetInnerHTML={{
                            __html: marked(bcProduct?.description),
                          }}
                        />
                      )} */}

                      {/* <div className="feature my-5">
                        <ul>
                          {sanityProduct?.feature.map((items, i) => (
                            <li
                              key={i}
                              style={{
                                backgroundImage: `url(${items?.featureIcon?.asset?.url})`,
                              }}
                            >
                              {items.featureTitle}
                            </li>
                          ))}
                        </ul>
                      </div> */}

                      {sanityProduct?.techSpecs && (
                        <div className="tech-specs">
                          <Button
                            id="toggler"
                            className="d-flex align-items-center justify-content-between"
                          >
                            <span>More Tech Specs </span>
                            <span>+</span>
                          </Button>
                          <UncontrolledCollapse toggler="#toggler">
                            <Card>
                              <CardBody>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: marked(
                                      sanityProduct.techSpecs || ""
                                    ),
                                  }}
                                  className="more-specs"
                                />
                              </CardBody>
                            </Card>
                          </UncontrolledCollapse>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
                <Col lg={{ span: 5, offset: 1 }} className="">
                  <div className="product-thumbnail">
                    {bcProductVariant?.image_url &&
                    bcProduct.options.length > 0 ? (
                      <div
                        className="product-thumbnail"
                        style={{
                          backgroundImage: `url(${bcProductVariant?.image_url})`,
                        }}
                      ></div>
                    ) : (
                      <ProductCarousel
                        images={sanityProduct?.imageGallery || []}
                      />
                    )}{" "}
                  </div>
                </Col>
              </Row>
            )}
          </div>
        </Container>
      </section>

      {sanityProduct?.section.map((item, i) => (
        <div className="section-wrapper" key={i}>
          {item.backgroundText && (
            <>
              {item.backgroundText.map((items, ii) => (
                <div
                  key={ii}
                  className="product-stories-section py-5"
                  style={{
                    backgroundImage: `url(${items?.bg?.asset?.url || ""})`,
                  }}
                >
                  <div className="container">
                    <div className="row d-flex align-items-center">
                      {items.column.map((col, iii) => (
                        <div
                          key={iii}
                          className={`col-sm-6 col-md-12 col-lg-6 ${col.position}`}
                        >
                          {col.mainImage ? (
                            <img
                              src={col.mainImage.asset.url}
                              className="img-fluid"
                              alt={col.mainImage.asset.url}
                            />
                          ) : null}
                          {col ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: marked(col.content || ""),
                              }}
                              className="product-markdown"
                            />
                          ) : null}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
          {item.video && (
            <>
              {item.video.map((vid, index) => (
                <div
                  className="hero-swiper video-section text-center"
                  key={index}
                >
                  <div className="container-fluid">
                    <div className="row">
                      {isHide ? (
                        <div onClick={playButton} className="video-thumbnail">
                          <img
                            style={{ cursor: "pointer" }}
                            class="img-fluid"
                            src={vid?.videoImage?.asset?.url || ""}
                          />
                        </div>
                      ) : (
                        <iframe
                          src={vid.videoEmbed + "?autoplay=1"}
                          allow="autoplay"
                          allowfullscreen
                          style={{ width: "100%", height: 600 }}
                          class="embed-responsive embed-responsive-16by9 embed-responsive-item"
                          frameborder="0"
                        ></iframe>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
          {item.imageWithText && (
            <>
              <div
                className="product-story-section py-5"
                style={{
                  backgroundImage: `url(${item?.imageWithText?.backgroundImage
                    ?.asset?.url || ""})`,
                }}
              >
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12 product-story-wrapper d-flex justify-content-center align-items-center flex-wrap">
                      <div
                        className="product-item h-100"
                        id={`masking-${bigcommerce_id}`}
                      >
                        <div className="mask-bg"></div>
                        <div
                          className="product-story-img h-100"
                          style={{
                            backgroundImage: `url(${item?.imageWithText
                              ?.mainImage?.asset?.url || ""})`,
                          }}
                        >
                          {/* <img
                            src={item?.imageWithText?.mainImage?.asset?.url}
                            className="img-fluid"
                            alt="Story Image"
                          /> */}
                        </div>
                      </div>
                      <div className="product-item h-100">
                        <div className="product-story-desc h-100">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: marked(
                                item.imageWithText.description || ""
                              ),
                            }}
                            className="product-story-markdown"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {item.text.length > 0 ? (
            <>
              <div className="product-specs-section py-5">
                <div className="container">
                  <div className="row">
                    <div className="col-12 text-center mb-5">
                      <h2 className="section-title">{item.title}</h2>
                    </div>
                    {item.text.map((i, index) => (
                      <div className="col-md-4 mx-auto product-specs-wrapper align-items-center mb-4">
                        <div className="product-item">
                          <div className="product-specs-desc">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: marked(i.description || ""),
                              }}
                              className="product-specs-markdown"
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>
      ))}
      {sanityProduct.certificates.length > 0 ? (
        <section className="certificate text-center">
          <div className="container">
            <div className="row align-items-start">
              {/* <div className="col-12 mb-5">
              <h2 className="section-title text-white">Unmatched Quality</h2>
            </div> */}
              {sanityProduct.certificates.map((item, e) => (
                <>
                  <div className="col-md-3 certificate-item">
                    {item.icon && (
                      <div className="certificate-icon mb-4">
                        <img
                          src={item?.icon?.asset?.url}
                          className="img-fluid"
                          alt="Story Image"
                        />
                      </div>
                    )}
                    {item.title && (
                      <div className="certificate-title">
                        <h5 className="text-white">{item.title}</h5>
                      </div>
                    )}
                  </div>
                </>
              ))}
            </div>
          </div>
        </section>
      ) : null}
      <section className="shop-about-section">
        <Container>
          <Row>
            <Col lg="10" className="mx-auto">
              <div className="arbor-content text-center text-white">
                {/* <h3 className="section-subtitle mb-5">Arbor Packs</h3> */}
                <div className="d-flex justify-content-center section-title mb-5 align-items-center">
                  <span className="mr-2">
                    <StaticImage
                      className="img-fluid"
                      src="../images/fluo-logo.png"
                      alt="Foundation Logo"
                    />
                  </span>
                </div>
                <h2 className="section-title mb-5">FLUO Foundation</h2>
                <p className="mb-6">
                  The FLUO Foundation is a community-galvanized 501(c)(3)
                  nonprofit devoted to educating, inspiring, and fostering a
                  greater understanding and stewardship of the mental health
                  needs of our children, teens, and young adults.
                </p>
                <Link to="/why-fluo" className="cta text-uppercase">
                  Why Fluo Foundation
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="shop-quote-section">
        <Container>
          <Row>
            <Col lg="10" className="mx-auto">
              <div className="flow-content text-center text-white">
                <div className="d-flex justify-content-center section-title mb-5 align-items-center">
                  <span className="ml-2">
                    <StaticImage
                      className="img-fluid ml-2"
                      src="../images/flow-logo.png"
                      alt="Logo"
                    />
                  </span>
                </div>

                <h2 className="mb-5 youthtouch">
                  “This is a quote. There will be many throughout the FLUO
                  website. Some short, some long.”
                </h2>
                <h5 className="youthtouch">~Nathan Hildreth, FLUO</h5>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* <section className="shop-review-section">
        <Container>
          <Row>
            <Col lg="3" className="mx-auto">
              <div className="foundation-content text-left text-white">
                <h4 className="font-weight-bold d-flex justify-content-start mb-5 align-items-center">
                  Reviews
                </h4>
                <p className="mb-6"></p>
              </div>
            </Col>
            <Col lg="4" className="mx-auto">
              <div className="foundation-content text-left text-white">
                <h1 className="section-title review-average font-weight-bold d-flex justify-content-start align-items-center">
                  4.8/5
                </h1>
                <h6 className="mb-6 text-white-50">Based on reviews</h6>

                <Link to="/" className="review-cta text-uppercase">
                  See All Reviews
                </Link>

                <Link
                  to="/"
                  className="review-submit text-uppercase text-decoration-underlined font-weight-bold ml-3"
                >
                  <u>Submit a Review</u>
                </Link>
              </div>
            </Col>
            <Col lg="5" className="mx-auto review-mobile">
              <div className="foundation-content text-left text-white">
                <p className="font-italic">
                  “Scelerisque in non eleifend amet etiam. Venenatis scelerisque
                  ac enim condimentum sit convallis viverra pretium.”
                </p>
                <h6 className="mb-6 text-white-50">John Doe</h6>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
      <div className="sticky-wrapper">
        <Sticky
          onFixedToggle={true}
          className="sticky-hide"
          stickyClassName="sticky-show"
          mode="bottom"
          boundaryElement=".contact-footer"
          hideOnBoundaryHit={true}
        >
          <Container className="py-2">
            <Row className="align-items-center">
              <Col xs={`${3} text-left d-none`}>
                <h5 className="m-0 text-white">
                  {bcProduct?.reviews_count} Reviews
                </h5>
              </Col>
              <Col xs={`${9} ml-auto`}>
                <Row className="align-items-center justify-content-end">
                  <Col xs="auto mb-2 mb-md-0" sm={8}>
                    <h5 className="m-0 text-white text-right">
                      {bcProduct?.name || ""}
                    </h5>
                  </Col>
                  <Col xs="auto">
                    <h5 className="m-0 text-white">
                      <CurrencyFormatter
                        currency={"USD"}
                        amount={
                          bcProductVariant?.calculated_price ||
                          bcProduct?.calculated_price ||
                          0
                        }
                      />
                    </h5>
                  </Col>
                  <Col xs="auto">
                    <div className="custom-addcart">
                      <AddToCart
                        item={bcProduct}
                        variant={bcProductVariant}
                        quantity={bcProductQty}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Sticky>
      </div>
    </Layout>
  )
}

export default ProductTemplate

export const productQuery = graphql`
  query productQuery($id: String!, $productId: Int!) {
    sanityProduct(id: { eq: $id }) {
      title
      heroBG {
        asset {
          url
        }
      }
      slug {
        current
      }
      imageGallery {
        asset {
          url
        }
      }
      id
      productHeading
      promotion
      feature {
        featureIcon {
          asset {
            url
          }
        }
        featureTitle
      }
      techSpecs
      section {
        title
        video {
          videoImage {
            asset {
              url
            }
          }
          videoEmbed
        }
        backgroundText {
          bg {
            asset {
              url
            }
          }
          column {
            mainImage {
              asset {
                url
              }
            }
            position
            content
          }
        }
        imageWithText {
          backgroundImage {
            asset {
              url
            }
          }
          description
          mainImage {
            asset {
              url
            }
          }
        }
        text {
          description
          title
        }
      }
      certificates {
        title
        icon {
          asset {
            url
          }
        }
      }
      productSubcategory {
        title
        id
      }
    }
    bigCommerceProducts(bigcommerce_id: { eq: $productId }) {
      id
      bigcommerce_id
      categories
    }
    allSanityCategory {
      nodes {
        title
        id
        productSubcategory {
          id
          title
        }
      }
    }
  }
`
